import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WidgetBaseProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import AdvisorLinks from "./advisorLinks";
import { PanelWithDivider } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ShortcutsWidget: React.FC<WidgetBaseProps> = (props) => {
  return (
    <Grid item container columnGap={2} direction="row">
      <PanelWithDivider title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Shortcuts)}>
        <AdvisorLinks />
      </PanelWithDivider>
    </Grid>
  );
};

export default ShortcutsWidget;
